// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + chunkId + "." + {"src_app_modules_maps_mjs":"4b1ac03e6b89ad597e80","src_app_modules_activity_mjs":"c528831b5ea1f9cda7be","src_app_modules_history_mjs":"5819d89185e882e21de1","src_app_modules_other_mjs":"9adf7df5f294cd37aa5e"}[chunkId] + ".mjs";
};